import styled, { css } from 'styled-components'
import type {
  QuotaBarStatus,
  StyledFillProps,
  StyledTrackProps,
} from './QuotaBar.types'

const sizeStyles = {
  small: css`
    height: 6px;
    border-radius: ${({ theme }) => theme.borderRadius.small};
  `,
  medium: css`
    height: 10px;
    border-radius: ${({ theme }) => theme.borderRadius.default};
  `,
}

const fillColor = (status: QuotaBarStatus) => css`
  background: ${({ theme }) => {
    switch (status) {
      case 'danger':
      case 'exceeded':
        return theme.colors.danger
      case 'warn':
        return theme.colors.warning
      case 'unlimited':
      case 'full':
        return theme.colors.primary
      case 'ok':
      default:
        return theme.colors.success
    }
  }};
`

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xsmall};
  width: 100%;
`

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacing.small};
  font-size: ${({ theme }) => theme.typography.fontSize.label};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const Label = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const Values = styled.span`
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const Track = styled.div<StyledTrackProps>`
  position: relative;
  width: 100%;
  background: ${({ theme }) => theme.colors.background.tertiary};
  overflow: visible;
  ${({ $size }) => sizeStyles[$size]};
`

export const Fill = styled.div<StyledFillProps>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ $ratio }) => `${Math.min(100, $ratio * 100)}%`};
  border-radius: inherit;
  transition: width ${({ theme }) => theme.transitions.medium};
  ${({ $status }) => fillColor($status)};
`

export const ExceedChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing.xsmall};
  font-size: ${({ theme }) => theme.typography.fontSize.label};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.danger};
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.danger};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-variant-numeric: tabular-nums;
`
